import { render, staticRenderFns } from "./studentsSp.vue?vue&type=template&id=ba40cf46&scoped=true"
import script from "./studentsSp.vue?vue&type=script&lang=js"
export * from "./studentsSp.vue?vue&type=script&lang=js"
import style0 from "./studentsSp.vue?vue&type=style&index=0&id=ba40cf46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba40cf46",
  null
  
)

export default component.exports